// extracted by mini-css-extract-plugin
export default {"bannerComponent":"Al-z","red":"Bl-z","calloutlink":"Cl-z","headerTopBanner":"Dl-z","bgcolorRed":"El-z","headerTopCallout":"Fl-z","searchBanner":"Gl-z","hideMobile":"Hl-z"};